const $ = jQuery;

export function restartVehicleSelect(field) {
    const $selectModel = $('select[name="model"]');
    const $selectYear = $('select[name="year"]');
    const $selectVehicle = $('select[name="vehicle"]');

    if (field === 'all') {
        $('select[name="marque"]').val('');

        $selectModel.val('');
        if (!$selectModel.hasClass('disabled')) {
            $selectModel.addClass('disabled');
        }
        $selectModel.find('option').remove();

        $selectYear.val('');
        $selectYear.closest('label').hide(0);
        $selectYear.find('option').remove();

        $selectVehicle.val('');
        $selectVehicle.closest('label').hide(0);
        $selectVehicle.find('option').remove();
    }

    if (field === 'marque') {
        $selectModel.val('');
        // $selectModel.closest('label').hide(0);
        $selectModel.find('option').remove();

        $selectYear.val('');
        $selectYear.closest('label').hide(0);
        $selectYear.find('option').remove();

        $selectVehicle.val('');
        $selectVehicle.closest('label').hide(0);
        $selectVehicle.find('option').remove();
    }

    if (field === 'model') {
        $selectYear.val('');
        $selectYear.closest('label').hide(0);
        $selectYear.find('option').remove();

        $selectVehicle.val('');
        $selectVehicle.closest('label').hide(0);
        $selectVehicle.find('option').remove();
    }

    if (field === 'year') {
        $selectVehicle.val('');
        $selectVehicle.closest('label').hide(0);
        $selectVehicle.find('option').remove();
    }
}
